import Sidebar from 'component/Sidebar/sidebar'
import React, { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { useT } from 'utils/i18n'

function AdminLayout() {
  const [openSideMenu, setOpenSideMenu] = useState(false)
  // عربي mirrors the whole dashboard (decision 2026-10-22); customer pages keep their own.
  const { lang, dir } = useT()
  const fullBleed = useLocation().pathname.startsWith('/campaigns/studio')

  // The studio is a full-screen editor with its own header (client design).
  if (fullBleed) return <Outlet />

  return (
    <div dir={dir} lang={lang}>
      <Sidebar openSideMenu={openSideMenu} setOpenSideMenu={setOpenSideMenu} />
      {/* Studio canvas: screens sit on the warm page; their cards and tables are white
          surfaces (plans/REDESIGN.md, phase 2). */}
      <main className='md:ms-[260px] md:w-[calc(100%-260px)] min-h-[100dvh] bg-canvas'>
        <div className='pt-[68px]'>
          <div className='px-4 py-6 md:px-8 md:py-8 max-w-[1510px] mx-auto'>
            <Outlet />
          </div>
        </div>
      </main>
    </div>
  )
}

export default AdminLayout
